import seoTags from './config/seoTags'

// TODO: GROWTH-664 -- Check that there are no trailing slash issues.
export function findSEO(pathname, tags = seoTags) {
  const normalizedPathname = pathname.replace(/^\/veil/, '').replace(/\/$/, '')
  return tags.find((tagSet) => tagSet.url_path === normalizedPathname)
}

// Default meta tag description text
export const defaultMetaDescription =
  'Suits and tuxedos for rent and for keeps. Modern styles made from 100% merino wool. Try free at home or visit a showroom near you. Free shipping.'
